var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInputText32Filled = function SvgIconInputText32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.02 13.647-1.4 3.427h2.8l-1.4-3.427Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.754 6.2a3.533 3.533 0 0 0-3.533 3.534v12.533A3.533 3.533 0 0 0 9.754 25.8h12.533a3.533 3.533 0 0 0 3.534-3.533V9.734A3.533 3.533 0 0 0 22.287 6.2H9.754Zm8.547 13.014h-4.553l-.88 2.14h-2.374l4.46-10.7h2.14l4.46 10.7h-2.373l-.88-2.14Z",
    fill: "current"
  })));
};
export default SvgIconInputText32Filled;